"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createThemeFromDeclarationMap = exports.createReactStyleFromCssStyle = void 0;
/*
turn a kebab cased string into a camel cased one
 */
function kebabToCamelCase(s) {
    return s.replace(/(-\w)/g, function (m) { return m[1].toUpperCase(); });
}
function createReactStyleFromCssStyle(originalStyle, sheetDriver) {
    var camelCasedVariantStyle = {};
    Object.keys(originalStyle).forEach(function (value) {
        if (originalStyle[value] !== undefined) {
            var newVal = originalStyle[value];
            if (sheetDriver) {
                newVal = sheetDriver.evalDeclarationValue(newVal);
            }
            camelCasedVariantStyle[kebabToCamelCase(value)] = newVal;
        }
    });
    return camelCasedVariantStyle;
}
exports.createReactStyleFromCssStyle = createReactStyleFromCssStyle;
function createThemeFromDeclarationMap(declarations) {
    var _a;
    var fontDecls = Object.keys(declarations).reduce(function (acc, key) {
        if (key === '-st-mixin')
            return acc;
        var camelCasedKey = kebabToCamelCase(key);
        acc[camelCasedKey] = declarations[key];
        return acc;
    }, {});
    // TODO: Take the '-st-mixin' const from stylable library
    return declarations['-st-mixin'] ? (_a = {}, _a[declarations['-st-mixin']] = fontDecls, _a) : {};
}
exports.createThemeFromDeclarationMap = createThemeFromDeclarationMap;
//# sourceMappingURL=style-conversions.js.map